<ion-content class="form-content"
  style="height: 100vh; background: rgba(0, 0, 0, 0.5)">

  <ion-grid>
    Reservation Success.
<br>
    {{orderDate}} <br>
    {{orderTime}} <br>
    {{menuItem.name | caption}} <br>
    {{profile.first_name}} <br>
    {{profile.last_name}}
<br>
    <ion-button mode="ios" (click)="close()">Kapat</ion-button>
  </ion-grid>
  
</ion-content>
